
import React, { Component } from 'react';
// import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import _ from 'lodash';
import moment from 'moment';
// import 'moment/min/moment-with-locales'
import 'moment/locale/th'

class BlogCard extends Component {
    render() {
        const { blog, max_characters, alignment, showPreHeader, showReadMore } = this.props;
        if (!blog) {
            return null;
        }
        moment.locale('th')
        // let date = moment(blog.published_date).add(1, 'Days').format('YYYYMMDD HH:mm:ss')
        // let blog_id = blog.blog_id;
        let max = max_characters || 120;
        let title = blog.blog_title;
        let cover_image = blog.cover_image;
        let blog_key = blog.blog_key;
        let blog_url = blog.blog_url
        let legacy = blog.legacy === 'legacy' ? true : false
        let content = ''
        let displayPreHeader = typeof showPreHeader !== "undefined"? showPreHeader: true;
        let displayReadMore = typeof showReadMore !== "undefined"? showReadMore: true;
        if(legacy){
            content = blog.content
        }else{
            let index = _.findIndex(blog.content, (content) => {
                return content.type === "TEXT"
            })
            if(index >= 0){
                content = blog.content[index].content
            }else{
                content = title
            }
        }
        return (
            <Link to={{ pathname : `/blog/${blog_url}`, blog_key : blog_key}}>
                <div className={`bt-blog-card row`}>
                    {/* 16*9 */}
                    <div className={`${alignment? (alignment === "horizontal"? "horizontal col-6": "col-12 mb-10"): "col-12 mb-10"}`}>
                        <div className="card-image padding-top-56">
                            <LazyLoad offset={100} height={0}>
                                <img alt={title} src={cover_image} />
                            </LazyLoad>
                        </div>
                    </div>
                    <div className={`card-detail ${alignment? (alignment === "horizontal"? "horizontal col-6": "col-12 text-center"): "col-12 text-center"}`}>
                        <div className="title">{title}</div>
                        {/* {result && <div className="description">{result[0].substr(0, 50) + (result[0].length > 50? '...': '')}}</div>} */}
                        {(displayPreHeader && content)? <div className="description">{content.substr(0, max) + (content.length > max? '...': '')}</div>: null}
                        {displayReadMore? <div className="read-more text-right">..อ่านต่อ</div>: null}
                    </div>
                </div>
            </Link>
        );
    }
}

export default BlogCard